import { render, staticRenderFns } from "./DisconnectCustomerComponent.vue?vue&type=template&id=5d0eae18&"
import script from "./DisconnectCustomerComponent.vue?vue&type=script&lang=js&"
export * from "./DisconnectCustomerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports